
export const UPDATE_FORM_SECTION_A = 'preform/UPDATE_FORM_SECTION_A';
export const UPDATE_FORM_SECTION_B = 'preform/UPDATE_FORM_SECTION_B';


export const updateFormSectionA = (payload) => ({
  type: UPDATE_FORM_SECTION_A,
  payload,
});

export const updateFormSectionB = (payload) => ({
  type: UPDATE_FORM_SECTION_B,
  payload,
});

const initialState = {
  PreFormSectionA: {
    PFapplicantName: '',
    PFprefix: '',
    PFdesignation: '',
    PForganisationName: '',
    PFregisteredOrganisationAddress: '',
    PFmailingAddress: '',
    PForganisationTelephone: '',
    PForganisationFax: '',
    PForganisationMobileNo: '',
    PForganisationEmail: '',
    PForganisationSocialMediaAccount: '',
    PForganisationWebsite: '',
    PFauthorisedProfile: '',
    organisationProfile: '',

  },
  PreFormSectionB: {
    PFaffiliatedOrganisationName: '',

  },

};

const preformReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM_SECTION_A:
      return {
        ...state,
        PreFormSectionA: {
          ...state.PreFormSectionA,
          ...action.payload,
        },
      };
    case UPDATE_FORM_SECTION_B:
      return {
        ...state,
        PreFormSectionB: {
          ...state.PreFormSectionB,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default preformReducer;
